(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
var T13 = {
        brakD: __pewniaki_inline_cfg[0],
        brakZ: __pewniaki_inline_cfg[1],
        lider: __pewniaki_inline_cfg[2],
        histor:__pewniaki_inline_cfg[3],
        pa1:   __pewniaki_inline_cfg[4],
        pa2:   __pewniaki_inline_cfg[5],
        pa5:   __pewniaki_inline_cfg[6],
        ni1:   __pewniaki_inline_cfg[7],
        ni2:   __pewniaki_inline_cfg[8],
        ni5:   __pewniaki_inline_cfg[9],
        zdanie:__pewniaki_inline_cfg[10],
        ponad2:__pewniaki_inline_cfg[11],
        w2:    __pewniaki_inline_cfg[12]
    };

window.PEWNIAKI_ANALIZA = {
    plik:   '/assets/json/db/' + __pewniaki_inline_cfg[13] + '/analizy/struktura.json',
    wersja: __pewniaki_inline_cfg[14],
    lata:   '/assets/json/db/' + __pewniaki_inline_cfg[15] + '/lata/',
    pula:   JSON.parse(String(__pewniaki_inline_cfg[16])),
    typuje: JSON.parse(String(__pewniaki_inline_cfg[17])),
    // Zakres lat: suma SUROWYCH licznikow ukladow z rocznikow (plan V2 §5.3).
    sumujLata: function (roczniki) {
        var hist = {}, N = 0;
        roczniki.forEach(function (r) {
            N += r.losowan || 0;
            Object.keys(r.parzyste || {}).forEach(function (s) { hist[s] = (hist[s] || 0) + r.parzyste[s]; });
        });
        return { losowan: N, parzyste: hist };
    },
    wnioski: function (o) {
        if (!o) return [T13.brakD];
        var h = o.parzyste || {}, keys = Object.keys(h).sort(function(a,b) { return h[b]-h[a] || String(a).localeCompare(String(b)); });
        if (!keys.length || !o.losowan) return [T13.brakZ];
        return [T13.lider.replace('%1', keys[0]).replace('%2', h[keys[0]]).replace('%3', o.losowan), T13.histor];
    },
    render: function (okno, klucz, dane) {
        var q = function (s) { return document.querySelector(s); };
        var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
        var f1 = function (v) { return v == null ? '—' : (Math.round(v * 10) / 10).toString().replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
        var typuje = dane.typuje || window.PEWNIAKI_ANALIZA.typuje;
        var modelP = (dane.model && dane.model.parzyste) || {};
        var sekcja = q('[data-parzyste]');
        if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
        if (sekcja) { sekcja.hidden = false; }
        var N = okno.losowan || 0, hist = okno.parzyste || {};
        var odm = function (n, a, b, c) { return n === 1 ? a : (n >= 2 && n <= 4 ? b : c); };
        var uklad = function (r) {
            return r + ' ' + odm(r, T13.pa1, T13.pa2, T13.pa5) + ' + ' + (typuje - r) + ' '
                 + odm(typuje - r, T13.ni1, T13.ni2, T13.ni5);
        };
        var najR = null, najIle = -1, wiersze = [];
        for (var r = 0; r <= typuje; r++) {
            var ile = hist[r] || 0, p = modelP[r];
            if (ile > najIle) { najIle = ile; najR = r; }
            var ph = N ? ile * 100 / N : null, pm = p != null ? p * 100 : null;
            var d = (ph != null && pm != null) ? ph - pm : null;
            wiersze.push('<tr><td>' + uklad(r) + '</td><td class="liczbowa">' + tys(ile) + '</td><td class="liczbowa">'
                + (ph == null ? '—' : f1(ph) + '%') + '</td><td class="liczbowa">' + (pm == null ? '—' : f1(pm) + '%')
                + '</td><td class="liczbowa">' + (d == null ? '—' : (d > 0 ? '+' : '') + f1(d)) + '</td></tr>');
        }
        q('[data-parzyste-tabela] tbody').innerHTML = wiersze.join('');
        var najHist = N && najR != null ? najIle * 100 / N : null;
        var najModel = najR != null && modelP[najR] != null ? modelP[najR] * 100 : null;
        var skrajne = (hist[0] || 0) + (hist[typuje] || 0);
        q('[data-parzyste-n]').textContent = tys(N);
        q('[data-parzyste-naj]').textContent = najR != null ? uklad(najR) : '—';
        q('[data-parzyste-naj-hist]').textContent = najHist == null ? '—' : f1(najHist) + '%';
        q('[data-parzyste-naj-model]').textContent = najModel == null ? '—' : f1(najModel) + '%';
        q('[data-parzyste-skrajne]').textContent = N ? tys(skrajne) : '—';
        q('[data-parzyste-skrajne-pct]').textContent = N ? f1(skrajne * 100 / N) + '%' : '—';
        q('[data-parzyste-zdanie]').textContent = (najHist == null || najModel == null) ? ''
            : T13.zdanie.replace('%1', uklad(najR)).replace('%2', f1(najHist)).replace('%3', f1(najModel))
                .replace('%4', Math.abs(najHist - najModel) > 2 ? T13.ponad2 : T13.w2).replace('%5', tys(N));
    }
};
})();
